import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const groupPharmaciesRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/pharmacies',
  validateSearch: z.object({
    pharmacyListId: z.number().optional(),
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/group/Pharmacies/GroupPharmaciesPage/GroupPharmaciesPage').then((d) => d.Route)
);
